import { useTranslation } from '@thoughtspot/i18n';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { Vertical } from "../../../utils/layouts";
import { Header, WithQueryHandler } from '../common';
import { LearnMore } from '../common/constants';
import { TranslationsKeys } from './constants';
import styles from './status-portal.module.scss';
const StatusPortalContainer = () => {
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    return (React.createElement(Vertical, { className: styles.statusPortalContainer, "data-testid": "StatusPortalComponentId" },
        React.createElement("div", { className: styles.headerWrapper },
            React.createElement(Header, { title: getTranslations(TranslationsKeys.TITLE), subTitle: getTranslations(TranslationsKeys.SUBTITLE), titleSize: "large", learnMoreKey: LearnMore.STATUS_PORTAL })),
        React.createElement(Typography, { variant: "p", className: styles.statusItemRow, noMargin: true },
            getTranslations(TranslationsKeys.LABEL),
            React.createElement(Link, { href: "#/status", target: "_blank" }, getTranslations(TranslationsKeys.LABEL_CLICK_HERE)))));
};
export const StatusPortal = () => (React.createElement(WithQueryHandler, null,
    React.createElement(StatusPortalContainer, null)));
//# sourceMappingURL=status-portal.container.js.map